module.exports = __webpack_public_path__ + "img/daimuzhi.7821cc42.jpg";